import { IPermission } from "../common/data/dtos/permission";
import { DELETE_TYPED_ASYNC, GET_TYPED_ASYNC, POST_TYPED_ASYNC, PUT_TYPED_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/Permission';

interface PermissionResponse {
    success: boolean;
    permission?: IPermission;
    permissions?: IPermission[];
    error?: string;
}

type CreatePermissionType = Omit<IPermission, 'id'> | Partial<IPermission>;

const createPermission = async (permission: CreatePermissionType): Promise<PermissionResponse> => {
    try {
        const response = await POST_TYPED_ASYNC<IPermission>(`${BASE_PATH}`, permission);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const deletePermission = async (id: string): Promise<PermissionResponse> => {
    try {
        const response = await DELETE_TYPED_ASYNC<IPermission>(`${BASE_PATH}/${id}`);

        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getPermissions = async (): Promise<PermissionResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IPermission>(`${BASE_PATH}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, permissions: response.collection };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getOnePermission = async (id: string): Promise<PermissionResponse> => {
    try {
        const response = await GET_TYPED_ASYNC<IPermission>(`${BASE_PATH}?id=${id}`);

        if (!response.success) {
            return { success: response.success, error: response.message || response.exception };
        }

        return { success: response.success, permission: response.entity };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const updatePermission = async (company: IPermission): Promise<PermissionResponse> => {
    try {
        const response = await PUT_TYPED_ASYNC<IPermission>(`${BASE_PATH}/${company.id}`, company);
        return {
            success: response.success,
            ...(!response.success ? { error: response.message || response.exception } : null),
        };
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    createPermission,
    deletePermission,
    getPermissions,
    getOnePermission,
    updatePermission,
};